export default import.meta.ROLLUP_FILE_URL_ZexbyYvdoubkV7gDvn0pOw